import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ServiceChangeComponent } from '@app/features/support/pages/service-change/service-change.component';
import { SupportTicketListComponent } from '@app/features/support/pages/support-ticket-list/support-ticket-list.component';
import { SupportTicketComponent } from '@app/features/support/pages/support-ticket/support-ticket.component';
import { MsalGuard } from '@azure/msal-angular';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'support-ticket-list',
    pathMatch: 'full',
  },
  {
    path: 'support-ticket-list',
    component: SupportTicketListComponent,
    canActivate: [MsalGuard],
    data: {
      title: 'Support',
      showBackButton: false,
      hideSupportButtons: false,
    },
  },
  {
    path: 'support-ticket-list/:caseid',
    component: SupportTicketListComponent,
    canActivate: [MsalGuard],
    data: {
      title: 'Support',
      showBackButton: false,
      hideSupportButtons: false,
    },
  },
  {
    path: 'submit-a-ticket',
    component: SupportTicketComponent,
    canActivate: [MsalGuard],
    data: {
      title: 'Support',
      alternateTitle: 'New Support Request',
      showBackButton: true,
      hideSupportButtons: true,
      isServiceRequest: false,
    },
  },
  {
    path: 'service-request',
    component: SupportTicketComponent,
    canActivate: [MsalGuard],
    data: {
      title: 'Support',
      alternateTitle: 'Request Additional Waste Pickup',
      showBackButton: true,
      hideSupportButtons: true,
      isServiceRequest: true,
    },
  },

  {
    path: 'service-change',
    component: ServiceChangeComponent,
    canActivate: [MsalGuard],
    data: {
      title: 'Support',
      alternateTitle: 'Service Change',
      showBackButton: true,
      hideSupportButtons: true,
      isServiceRequest: true,
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SupportRoutingModule {}
